module.exports = __webpack_public_path__ + "static/media/editIconInactive.368b1f34.svg";